import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-botao-responder',
  templateUrl: './botao-responder.component.html',
  styleUrls: ['./botao-responder.component.scss']
})
export class BotaoResponderComponent {
  /**
   * esse botão aparece na parte inferior do container de mensagens nas páginas de detalhes
   */
}
